<template>
  <div>
    <h3 class="om-page-heading">
      <label for="search">{{ $tr('Lista zwrotów', 'ReturnList') }}</label>
    </h3>
    <form class="om-search flex sb">
      <input id="search" v-model="searchValue" class="om-search__input fg-20" :placeholder="$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList')" :title="$tr('Imię i nazwisko lub numer zamówienia', 'ReturnList')">
      <button class="om-btn om-search__submit" :placeholder="$tr('', 'ReturnList')" @click.prevent="searchAction" type="submit">
        {{ $tr('Szukaj', 'ReturnList') }}
      </button>
    </form>
    <div class="om-list-heading flex sb">
      <div v-if="search != ''" class="flex wrap">
        <div class="om-list-heading__label om-list-heading__label--bright">{{ $tr('Wyniki wyszukiwania:', 'ReturnList') }}</div>
        <div class="om-list-heading__label">{{ search }}</div>
        <div class="om-list-heading__label om-list-heading__label--num">({{ filteredCount }})</div>
      </div>
      <div class="flex wrap">
        <label class="om-list-heading__label">{{ $tr('Pokaż', 'ReturnList') }}</label>
        <dropdown v-on:change="changePerPage" :items="itemsPerPage" :default-label="defaultPerPage.name" :default-value="defaultPerPage.value"></dropdown>
      </div>
      <div v-if="storesDefaultFilter" class="flex wrap">
        <label class="om-list-heading__label">{{ $tr('Sklep', 'ReturnList') }}</label>
        <dropdown v-on:change="changeFilterByStore" :items="storesFilter" :default-label="storesDefaultFilter.name" :default-value="storesDefaultFilter.value"></dropdown>
      </div>
      <radio :items="dateRangesFilter" v-on:change="changeDateRange"></radio>
      <div class="flex wrap">
        <label class="om-list-heading__label">{{ $tr('Wyświetl:', 'ReturnList') }}</label>
        <dropdown
          v-on:change="changeFilterByState"
          :items="filterByStates"
          :default-label="defaultByStates.name"
          :default-value="defaultByStates.value"></dropdown>
      </div>
    </div>

    <table v-if="!noContent" class="om-table">
      <thead>
        <tr>
          <!--<th v-for="column in columns">-->
              <!--{{ column }}-->
          <!--</th>-->
          <th>{{ columns.reference }}</th>
          <th>{{ columns.firstname }}</th>
          <th>{{ columns.store }}</th>
          <th>{{ columns.data }}</th>
          <th>{{ columns.amount }}</th>
          <th>{{ columns.notes }}</th>
          <th>{{ columns.status }}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in pageContent">
          <td class="reference">{{ item.reference }}</td>
          <td>
            <div class="font-normal" v-html="highlight(item.firstname + ' ' + item.lastname, search)"></div>
            <div>{{ item.email }}</div>
            <div>{{ item.phone }}</div>
          </td>
          <td>{{ typeof item.store_return !== 'undefined' ? item.store_return.name : '' }}</td>
          <td v-html="item.payment_info"></td>
          <td class="total">{{ item.total_return }} {{ item.currency }}</td>
          <td>{{ item.notes }}</td>
          <td class="status" :style="{color: item.statusColor}">{{ item.status }}</td>

          <td class="more">
            <router-link :to="{name: 'Return', params: {reference: item.reference}}">
              <i class="om-ico-zoom" aria-hidden="true"></i>
            </router-link>
          </td>

        </tr>
      </tbody>

    </table>
    <div v-else="" class="om-information">
      {{ $tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'ReturnList') }}
    </div>
    <div class="om-list-footer flex sb">
      <div></div>
      <paginator
        :items-per-page="currentPerPage"
        v-on:change="updatePageContent"
        :passive-mode="paginatorPassive"
        :request="request"
        :update-force="requestUpdateForce"></paginator>
    </div>
  </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'
  import dateRangesMixin from '../../mixins/date-ranges'

  export default {
    mixins: [dateRangesMixin],
    components: {Paginator},
    name: 'return-list',
    data () {
      return {
        list: [],
        defaultPerPage: {name: 3, value: 3},
        itemsPerPage: [{name: 3, value: 3}, {name: 6, value: 6}, {name: 12, value: 12}, {name: 24, value: 24}, {name: 48, value: 48}],
        currentPerPage: 3,
        pageContent: [],
        filteredCount: 1,
        fList: null,
        filterByStates: [],
        defaultByStates: {},
        /* table sort functionality */
        sortKey: 'name',

        reverse: false,

        searchValue: '',
        search: '',

        columns: {},

        paginatorPassive: true,
        requestParams: {
          route: 'return-list',
          params: {}
        },
        requestUpdateForce: 1,
        // filter by stores
        storesFilter: [],
        storesDefaultFilter: null
      }
    },
    mounted () {
      this.columns = {
        'reference': this.$tr('Nr zamówienia', 'ReturnList'),
        'firstname': this.$tr('Imię i nazwisko', 'ReturnList'),
        'store': this.$tr('Sklep', 'ReturnList'),
        'data': this.$tr('Dane do przelewu', 'ReturnList'),
        'amount': this.$tr('Kwota zwrotu', 'ReturnList'),
        'notes': this.$tr('Uwagi', 'ReturnList'),
        'status': this.$tr('Status', 'ReturnList')
      }
      let def = {
        name: this.$tr('Wszystko', 'ReturnList'),
        value: null
      }
      this.filterByStates.push(def)
      this.defaultByStates = def
      this.$http.get(this.$router.options.getApiRoute('return-states'))
      .then((r) => {
        let statesFilters = r.body.states.map((el, key) => {
          return {
            name: el,
            value: el
          }
        })
        this.filterByStates = this.filterByStates.concat(statesFilters)
      })
      let initialStoreFilter = {
        name: this.$tr('--', 'ReturnList'),
        value: null
      }
      this.storesDefaultFilter = initialStoreFilter
      this.storesFilter.push(initialStoreFilter)
      this.$http.get(this.$router.options.getApiRoute('return-stores'))
      .then((resp) => {
        if (resp.ok) {
          let storesFilter = resp.body.stores.map((el, key) => {
            return {
              name: el.name,
              value: el
            }
          })
          this.storesFilter = this.storesFilter.concat(storesFilter)
        }
      })
    },
    methods: {
      changePerPage (ev) {
        this.currentPerPage = ev
      },
      changeFilterByState (val) {
        if (val !== null) {
          if (typeof this.requestParams.params['filter'] !== 'object') {
            this.requestParams.params['filter'] = {}
          }
          this.requestParams.params.filter['status'] = val
        } else {
          if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['status'] !== 'undefined') {
            delete this.requestParams.params['filter']['status']
          }
        }
        this.requestUpdateForce++
      },
      changeFilterByStore (val) {
        if (val !== null) {
          if (typeof this.requestParams.params['filter'] !== 'object') {
            this.requestParams.params['filter'] = {}
          }
          this.requestParams.params.filter['shop'] = val
        } else {
          if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['shop'] !== 'undefined') {
            delete this.requestParams.params['filter']['shop']
          }
        }
        this.requestUpdateForce++
        console.log(val)
      },
      changeDateRange (val) {
        if (val !== null) {
          let to = new Date(Date.now())
          to.setSeconds(59)
          to.setMinutes(59)
          to.setHours(23)
          this.requestParams.params['date_from'] = val
          this.requestParams.params['date_to'] = to.toISOString()
        } else {
          if (typeof this.requestParams.params['date_from'] !== 'undefined') {
            delete this.requestParams.params['date_from']
          }
          if (typeof this.requestParams.params['date_to'] !== 'undefined') {
            delete this.requestParams.params['date_to']
          }
        }
        this.requestUpdateForce++
        console.log(val)
      },
      searchAction () {
        if (this.paginatorPassive) {
          if (this.searchValue !== '') {
            this.requestParams.params['query'] = this.searchValue
          } else {
            delete this.requestParams.params['query']
          }
          this.requestUpdateForce++
        } else {
          this.search = this.searchValue
        }
      },
      sortBy (sortKey) {
        this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
        this.sortKey = sortKey
      },
      updatePageContent (content) {
        this.pageContent = content
      },
      highlight (words, query) {
        let iQuery = new RegExp(query, 'ig')
        return words.toString().replace(iQuery, (matchedTxt) => {
          return (`<span class="highlight">${matchedTxt}</span>`)
        })
      }
    },
    computed: {
      filteredList () {
        let filtered = this.list
        if (this.search !== '') {
          let pattern = new RegExp(this.search, 'i')
          filtered = filtered.filter((item) => {
            return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern)
          })
        }
        this.filteredCount = filtered.length
        return filtered
      },
      request () {
        return this.requestParams
      },
      noContent () {
        return !(this.pageContent instanceof Array && this.pageContent.length)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/settings";
    @import "../../assets/scss/utilities";

</style>



// WEBPACK FOOTER //
// ReturnList.vue?0858193c